import * as actionTypes from '../actions/Actions';

export const initialState = {
  data: {
    isOpen: false,
    phone: '',
    feature: '',
    next: false,
    access_to: '',
    authenType: null,
    notify: '',
    style: ''
  },
};

// ==============================|| Otp REDUCER ||============================== //

const otpReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_OTP_FORGOT_MODAL:
      return {
        ...state,
        data: {
          ...state.data,
          isOpen: true,
          phone: action.phone,
          feature: action.feature,
          notify: ''
        }
      };
    case actionTypes.SHOW_OTP_LOGIN_MODAL:
      return {
        ...state,
        data: {
          ...state.data,
          isOpen: true,
          phone: action.phone,
          feature: action.feature,
          next: false,
          notify: ''
        }
      };
    case actionTypes.GET_MESSAGE_OTP:
      return {
        ...state,
        data: {
          ...state.data,
          notify: action.notify,
          style: action.style
        }
      }
    case actionTypes.CLEAR_MESSAGE_OTP:
      return {
        ...state,
        data: {
          ...state.data,
          notify: '',
          style: '',
        }
      }
    case actionTypes.SHOW_OTP_GG_AUTHEN:
      return {
        ...state,
        data: {
          ...state.data,
          isOpen: true,
          phone: action.phone,
          authenType: action.authenType,
          feature: action.feature,
          notify: ''
        }
      }
    case actionTypes.GO_TO_NEXT_STEP:
      return {
        ...state,
        data: {
          ...state.data,
          next: true,
        }
      };
    case actionTypes.CLOSE_OTP_MODAL:
      return {
        ...state,
        data: {
          ...state.data,
          isOpen: false
        }
      };
    case actionTypes.SHOW_OTP_SIGN_UP_MODAL:
      return {
        ...state,
        data: {
          ...state.data,
          isOpen: true,
          phone: action.phone,
          feature: action.feature,
          next: false,
        }
      };

    default:
      return state;
  }
};

export default otpReducer;
